import { createTickersFilters } from '@/filters/createTickersFilters'
import { extractFormData, extractZodFromForm } from '@/utils/forms'
import { ref } from 'vue'
import z from 'zod'

export function useTickersFilters() {
  const filters = createTickersFilters()
  const initValues = extractFormData(filters)
  const formData = ref({ ...initValues })
  const zodForm = z.object(extractZodFromForm(filters))

  return { formData, zodForm, filters }
}
